import {Component} from '@angular/core';
import {AppStateService} from '../../shared/app-state.service';
import {map} from 'rxjs/operators';

const AQ_IMAGE = require('../../../static/persona-promotion/AQ_Persona_Launch_MyAquent_576x756_v1.png');

const AQ_URL = 'https://aquent.com/ux-analysis-tool?utm_campaign=AQ_NA_Persona&utm_source=myaquent&utm_medium=display&utm_content=MyAQ-030921';

@Component({
  selector: 'persona-promotion',
  templateUrl: './persona-promotion.component.html',
  styleUrls: ['./persona-promotion.component.scss']
})
export class PersonaComponent {

  brand$ = this.AppState.brand$;
  image$ = this.brand$.pipe(map(brand => AQ_IMAGE));
  url$ = this.brand$.pipe(map(brand =>  AQ_URL));

  constructor(private AppState: AppStateService) {
  }
}
